import type { Config } from '../../_config'
import type { UseCase } from '../../_kernel/architecture'
import type { Market } from '../domain/Market'
import type { SharedRepository } from '../domain/SharedRepository'
import { SharedRepositoryProxy } from '../infrastructure/SharedRepositoryProxy'

export default class GetCurrentMarketSharedUseCase implements UseCase<undefined, Market> {
  static readonly USE_CASE_NAME = 'GetCurrentMarketSharedUseCase'

  static create({ config, repository }: { config: Config; repository?: SharedRepository }) {
    return new GetCurrentMarketSharedUseCase(repository ?? SharedRepositoryProxy.create({ config }))
  }

  constructor(private repository: SharedRepository) {}

  async execute() {
    return this.repository.market()
  }
}
